import iconRules from '../../icon/feature';

const dark = (params) => iconRules.dark(params);

export default dark;
